import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { StringFormatter } from '@repo/toolkit/string'
import InnerBox from '@repo/ui/inner-box'
import Typography from '@repo/ui/typography'

import useTranslate from '../../../../../lib/hooks/use-translate'
import { OlBasic } from '../../../../../lib/types/models/ol/ol'
import { formatPhoneNumber } from '../../../../../utils/functions/format-phone-number'
import LabelWithText from '../../../ols/label-with-text'

type Props = {
  ol: OlBasic
}

const StaffPersonalSpaceLocalOrganizerSection = ({ ol }: Props) => {
  const { t } = useTranslate()
  return (
    <InnerBox className="rounded-lg p-3 bg-white-hover">
      <div className="flex items-center gap-2">
        <Typography variant="text" color={tailwindColors.primary.DEFAULT}>
          {t('staff.personal.space.my.journeys.details.tab.home.organizer.local')}
        </Typography>
      </div>
      <div className="h-2" />
      <div className="grid grid-cols-2 gap-2 mobile:grid-cols-1">
        <LabelWithText
          label={t('staff.personal.space.my.journeys.details.tab.home.organizer.lastName')}
          data={ol.mainContactLastName.toUpperCase()}
        />
        <LabelWithText
          label={t('staff.personal.space.my.journeys.details.tab.home.organizer.firstName')}
          data={
            ol.mainContactFirstName ? StringFormatter.capitalize(ol.mainContactFirstName) : '-'
          }
        />
        <LabelWithText
          label={t('staff.personal.space.my.journeys.details.tab.home.organizer.phone')}
          data={formatPhoneNumber(ol.mainContactPhone)}
        />
        <LabelWithText
          label={t('staff.personal.space.my.journeys.details.tab.home.organizer.email')}
          data={ol.mainContactEmail}
        />
      </div>
    </InnerBox>
  )
}

export default StaffPersonalSpaceLocalOrganizerSection
